//@ts-nocheck

const accordion_main = () => {
  const accordions = document.querySelectorAll(".js-accordion");
  if (accordions.length == 0) {
    return;
  }
  const resize = () => {
    let max = 0;
    let coef = 20;
    if (window.innerWidth < 1366) {
      coef = 30;
    }
    accordions.forEach((item) => {
      let height = item.querySelector(".js-accordion-title");
      let marginHeight = item.querySelector(".js-accordion-content");
      marginHeight = parseFloat(getComputedStyle(marginHeight).marginBottom);
      height = height?.getBoundingClientRect().height;
      if (window.innerWidth > 1365) {
        if (height > max) {
          max = height;
        }
      } else {
        item.style.maxHeight = height + coef + "px";
      }
    });
    if (window.innerWidth > 1365) {
      accordions.forEach((item) => {
        item.style.maxHeight = max + coef + "px";
      });
    }
  };
  resize();
  window.addEventListener("resize", resize);
  accordions.forEach((item) => {
    let sign = item.querySelector(".js-accordion-sign");
    let title = item.querySelector(".js-accordion-title");
    sign.addEventListener("click", (e) => {
      console.log(123);
      item.classList.toggle("active");
    });
    title.addEventListener("click", (e) => {
      item.classList.toggle("active");
    });
  });
};

export default accordion_main;
